<template>
  <div
    class="flex flex-col border-qwraylight border-solid border-t-2 py-4"
    v-bind:class="last ? 'border-b-2' : ''"
  >
    <div class="flex flex-row justify-between items-center flex-1">
      <div class="text-qwraylight text-16px flex tracking-2.4px">
        {{ $t(name) }}
      </div>
      <div @click="isOpen = !isOpen" class="clickable-cross">
        <div class="mr-4 Grid w-14px h-14px">
          <div class="HLine"></div>
          <div :class="isOpen ? 'Hide' : ''" class="VLine"></div>
        </div>
      </div>
    </div>
    <div :class="isOpen ? 'flex flex-col' : 'hidden'">
      <div v-for="(link, index) in links" v-bind:key="index">
        <a
          v-if="link.isExternal === true"
          class="text-white ml-5 text-md mt-4"
          :href="link.ref"
          target="_blank"
          >{{ $t(link.text) }}
        </a>
        <router-link
          v-else
          class="text-white ml-5 text-16px mt-4"
          :to="{ path: link.ref }"
        >
          {{ $t(link.text) }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n';

export default {
  data() {
    return {
      isOpen: false,
      locale: i18n.locale,
    };
  },
  props: ['links', 'last', 'name'],
};
</script>

<style scoped>
.Grid {
  display: grid;
  justify-items: center;
  align-items: center;
  width: 14px;
  height: 14px;
}

.HLine,
.VLine {
  background: #a1b1b5;
  grid-area: 1 / 1;
}
.HLine {
  width: 14px;
  height: 2px;
}
.VLine {
  width: 2px;
  height: 14px;
}
.Hide {
  visibility: hidden;
}
</style>
